import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps, chakra, Heading, HeadingProps, HStack, Separator, Text, TextProps, VStack } from '@chakra-ui/react';
import { resolvePaywallIntent } from '@src/components/sco/Conversion/intent';
import { HomePaths } from '@src/components/sco/Home/HomePaths';
import { MasonryGridBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/MasonryGridBlock';
import { MembershipPricingPage } from '@src/components/sco/Pricing/MembershipPricingPage';
import { PricingKeyStats } from '@src/components/sco/Pricing/PricingKeyStats';
import { PricingNotSureCallout } from '@src/components/sco/Pricing/PricingNotSureCallout';
import { UserGroupRequestGoalsList } from '@src/components/sco/Requests/UserGroupRequestGoalsList';
import { SignupRequestChatIntake } from '@src/components/sco/SignupRequestChatIntake';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export default function PricingPage() {
  const $ = _c(22);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = resolvePaywallIntent("default");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const plansIntent = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ScoSiteNavBar />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      paddingBottom: [8, 10, 12]
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      as: "h1",
      children: <a href="/accelerator/start">{"Tell us your goal. "}{t3}<chakra.span {...{
          backgroundImage: "linear-gradient(90deg, #d97258 0%, #9858a3 100%)",
          backgroundClip: "text",
          color: "transparent"
        }}>We’ll show you how to get there.</chakra.span></a>
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <UserGroupRequestGoalsList compact={true} ctaLabel="Continue" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== getBreakpointValue) {
    t6 = getBreakpointValue([true, true, false]);
    $[6] = getBreakpointValue;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <HomePaths>{t5}<SignupRequestChatIntake funnelIdentifier="accelerator-start" hideFileAttach={t6} /></HomePaths>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box paddingTop={[4, 6, 8, 12]}><PricingKeyStats /></Box>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <Block boxProps={t2} headingProps={t4}>{t7}{t8}</Block>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <OrDivider />;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      paddingTop: [8, 10, 12]
    };
    t12 = {
      paddingX: [4, 6, 8]
    };
    $[14] = t11;
    $[15] = t12;
  } else {
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      as: "h2",
      children: "Explore plans",
      size: ["2xl", "3xl", "4xl"]
    };
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      children: plansIntent.supporting,
      color: "fg.muted",
      fontSize: ["md", "lg", "lg", "xl"],
      maxWidth: "2xl",
      textWrap: "balance"
    };
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Block boxProps={t11} childBoxProps={t12} headingProps={t13} textProps={t14}><Box id="compare" marginX="auto" maxWidth="5xl" width="full"><MembershipPricingPage align="center" closingExtra={<PricingNotSureCallout variant="inline" />} showFree={true} showHero={false} /></Box></Block>;
    t16 = <MasonryGridBlock background="colorPalette.bg" />;
    $[18] = t15;
    $[19] = t16;
  } else {
    t15 = $[18];
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t9) {
    t17 = <Box>{t1}{t9}{t10}{t15}{t16}</Box>;
    $[20] = t9;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  return t17;
}

/** The page offers two ways in (a goal-built roadmap, or a plan); the rule marks the fork between them. */
const OrDivider = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box background="colorPalette.panel" paddingX={6} width="full"><HStack gap={4} marginX="auto" maxWidth="md"><Separator flex={1} /><Text color="fg.muted" textStyle="labelXs">or</Text><Separator flex={1} /></HStack></Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const Block = props => {
  const $ = _c(25);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t0 = props.background || "colorPalette.panel";
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([12, 12, 14, 14, 20]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([12, 12, 14, 14, 20]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = props.boxProps;
  const t4 = props.innerBoxProps;
  let t5;
  if ($[4] !== getBreakpointValue || $[5] !== props.children || $[6] !== props.headingProps || $[7] !== props.textProps) {
    t5 = (props.headingProps || props.textProps) && <VStack align="center" gap={getBreakpointValue([2, 2, 4])} marginBottom={props.children && getBreakpointValue([6, 6, 8, 10, 12])} paddingX={getBreakpointValue([4, 6, 8])} textAlign="center" width="full">{props.headingProps && <Heading as="h3" size={getBreakpointValue(["2xl", "3xl", "4xl", "4xl", "5xl"])} textAlign="center" {...props.headingProps} />}{props.textProps && <Text fontSize={getBreakpointValue(["lg", "lg", "xl", "xl", "2xl"])} maxWidth="container.lg" {...props.textProps} />}</VStack>;
    $[4] = getBreakpointValue;
    $[5] = props.children;
    $[6] = props.headingProps;
    $[7] = props.textProps;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== getBreakpointValue) {
    t6 = getBreakpointValue([2, 2, 8]);
    $[9] = getBreakpointValue;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props.childBoxProps || $[12] !== props.children || $[13] !== t6) {
    t7 = <Box paddingX={t6} {...props.childBoxProps}>{props.children}</Box>;
    $[11] = props.childBoxProps;
    $[12] = props.children;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props.innerBoxProps || $[16] !== t5 || $[17] !== t7) {
    t8 = <Box marginX="auto" maxWidth="container.xl" {...t4}>{t5}{t7}</Box>;
    $[15] = props.innerBoxProps;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== props.boxProps || $[20] !== t0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t8) {
    t9 = <Box background={t0} gap={0} paddingBottom={t1} paddingTop={t2} width="full" {...t3}>{t8}</Box>;
    $[19] = props.boxProps;
    $[20] = t0;
    $[21] = t1;
    $[22] = t2;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};